import {Chip, IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../system/thead";
import {PaginateContext} from "../../context/paginate";
import {UnpaidWorkContext} from "../../context/unpaid_work";

const TABLE_HEAD = ["#", "کاربر", "مشاور", "نوع", "گرایش", "هزینه", "عملیات"];

export function UnpaidWorkGrid() {

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const {
    unpaidWorks,
    setUnpaidWork,
    setOpen,
  } = useContext(UnpaidWorkContext);

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "کاربر": "person_name",
    "مشاور": "agent_name",
    "نوع": "product_type",
    "گرایش": "branch_name",
    "هزینه": "price",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "کاربر": true,
    "مشاور": true,
    "نوع": true,
    "گرایش": true,
    "هزینه": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {unpaidWorks.map(
          ({
             id,
             person_name,
             person_phone,
             agent_name,
             agent_phone,
             product_type,
             branch_name,
             price
           }, index) => {
            const isLast = index === unpaidWorks.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr
                key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col items-center px-4">
                    <Typography color="blue-gray">
                      {person_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(person_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col items-center px-4">
                    <Typography color="blue-gray">
                      {agent_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(agent_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip
                      color={product_type === 'service' ? 'teal' : product_type === 'consultation' ? 'cyan' : 'amber'}
                      value={product_type === 'service' ? 'خدمات' : product_type === 'consultation' ? 'مشاوره' : ''}
                    />
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {branch_name}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(price, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="ویرایش">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setUnpaidWork(unpaidWorks[index]);
                      setOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}